import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import configureStore from './store/configure';

import WebhookEvents from './webhook_events';

export default class WebhookEventIndex extends React.Component {
  static propTypes = {
    eventTypes: PropTypes.array.isRequired,
    paths: PropTypes.object.isRequired
  };

  store = configureStore({
    paths: this.props.paths,
    query: {
      page: 1,
      searchText: '',
      minDate: null,
      maxDate: null,
      eventTypes: this.props.eventTypes,
      statusFilter: [],
      identifier: '',
      eventTypeFilter: []
    },
    search: {
      webhookEvents: [],
      isFetching: true,
      meta: {
        currentPage: 0,
        pageSize: 25,
        totalCount: 0,
        totalPages: 0
      }
    }
  });

  render() {
    return (
      <Provider store={this.store}>
        <WebhookEvents />
      </Provider>
    );
  }
}